import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VidSluchaj } from '../beans/vid-sluchaj';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class VidSluchajService {

	private readonly baseUrl = environment.serviceBaseUrl + '/api/vidSluchaj';

	constructor(private http: HttpService) { }

	getAll(): Observable<VidSluchaj[]> {
		return this.http.get<VidSluchaj[]>(this.baseUrl);
	}

	save(v: VidSluchaj): Observable<VidSluchaj> {
		return this.http.post<VidSluchaj>(this.baseUrl, v);
	}

	delete(id: number): Observable<any> {
		return this.http.delete<any>(this.baseUrl + '/' + id);
	}

	/** Преизчислява vid_sluchaj за 'Незнаен'/'Трудова злополука' (admin-only). */
	recompute(): Observable<{ changed: number }> {
		return this.http.post<{ changed: number }>(this.baseUrl + '/recompute', {});
	}
}
